module.exports = __webpack_public_path__ + "img/primary.2c0533e6.png";